import styled from 'styled-components';

export const PopularBusOperator = styled.section(
  props => `
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 7rem;
    h3 {
        font-size: 2.2rem;
        color: rgb(20, 24, 35);
        font-family: ${props.theme.font.fontFamily};
        font-weight: bold;
        padding-bottom: 1.5rem;
    }
`,
);

export const ContentBlock = styled.div(
  props => `
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
    border-radius: 0.6rem;
    padding: 3rem 2rem;
    display: flex;
    width: 100%;
    p {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
    }
    a {
        font-size: 1.8rem;
        text-transform: uppercase;
        font-weight: bold;
        font-family: ${props.theme.font.fontFamily};
        padding: 0 0.5rem;
    }
    span {
        padding: 0 1.5rem;
        font-size: 1.8rem;
        color: #999;
        font-weight: bold;
        font-family: ${props.theme.font.fontFamily};
    }
`,
);
